import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import clsx from "clsx";
import { forwardRef } from "react";

interface ScrollAreaProps {
  children: React.ReactNode;
  height: number | string;
  showScrollBar: boolean;
  className?: string;
}

const ScrollArea = forwardRef<HTMLDivElement, ScrollAreaProps>(
  ({ height, showScrollBar, children, className }, ref) => {
    return (
      <ScrollAreaPrimitive.Root
        type="scroll"
        className={clsx("flex w-full flex-col overflow-hidden", className, {
          "pr-2": showScrollBar,
        })}
        style={{ maxHeight: height }}
      >
        <ScrollAreaPrimitive.Viewport
          ref={ref}
          className="!block h-full w-full flex-1"
        >
          {children}
        </ScrollAreaPrimitive.Viewport>
        <ScrollAreaPrimitive.Scrollbar
          orientation="vertical"
          className={`flex w-2 touch-none select-none justify-center px-0.5 ${showScrollBar ? "visible" : "hidden"}`}
        >
          <ScrollAreaPrimitive.Thumb className="duration-600 !w-[2px] rounded bg-w-16 bg-clip-padding transition-colors ease-out hover:!w-[4px]" />
        </ScrollAreaPrimitive.Scrollbar>
      </ScrollAreaPrimitive.Root>
    );
  }
);

ScrollArea.displayName = "ScrollArea";

export { ScrollArea };
